import { render, staticRenderFns } from "./specs.vue?vue&type=template&id=5974c3fe&"
import script from "./specs.vue?vue&type=script&lang=js&"
export * from "./specs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports